module.exports = __webpack_public_path__ + "static/media/clipboard.5a0066b2.svg";